<template>
    <div class="loginVue" v-loading="loading">
         <div class="login-wrap" v-if="loginHide">
            <div class="container">
                <div class="login-center">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
                                <img v-if="domainLogo && domainLogo != '' && domainLogo != 'NULL'" :src="(domainLogo)" id='img-upload' />
                                <img v-if="!domainLogo || domainLogo == '' || domainLogo == 'NULL'" src="static/assets/images/logo.png" id='img-upload' />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">
                                <div class="login-page-language-selection">
                                    <div class="o-login-field mb-15">
                                        <label>{{$t('language')}}: </label>
                                        <select v-model="languageSelected" @change="onLanguageSelected()">
                                            <option v-for="(language, index) in preferedLanguages" :key="index" :value="language.value">{{ $t(language.label) }}</option>
                                        </select>
                                    </div>
                                </div>
                                <transition name="">
                                    <div v-if="tab == 'loginScreen'" class="login-screen">                                        
                                       <form autocomplete="off">
                                        <div class="form-group">
                                            <div class="clearfix">
                                
                                                <div class="form-group-left o-login-field">
                                                    <!-- <label>E-MAIL :</label> -->
                                                    <label>{{ $t('email') }} :</label>
                                                </div>
                                                <div class="form-group-right o-login-field">
                                                    <input autocomplete="off" @keyup.enter="validate" type="text" class="form-control u-transparent" :placeholder="$t('enter_your_email')" v-model="email" id="email" v-validate="{ required: true, email: true }" name="email">
                                                    <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="clearfix">
                                                <div class="form-group-left o-login-field">
                                                    <label>{{ $t('password') }} :</label>
                                                </div>
                                                <div class="form-group-right o-login-field">
                                                    <input autocomplete="off" @keyup.enter="validate" type="password" class="form-control u-transparent" :placeholder="$t('enter_your_password')" v-model="password" id="pwd" v-validate="{ required: true}" name="password">
                                                    <span v-show="errors.has('password') && this.validation_err!=0" class="err-msg">{{ errors.first('password') }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">

                                            <div class="clearfix">
                                                <a href="javascript: void(0)" @click="validate()" class="c-solid-btn c-solid-btn--green o-login-btn">
                                                    {{ $t('login') }}
                                                </a>
                                            
                                                <div class="forget-float-right ps2" style="padding-bottom: 10px;">
                                                    <a href="javascript: void(0)" @click="goToForget()" class="o-forget-password font-red">
                                                        <!-- GET NEW PASSWORD? -->
                                                        {{ $t('forgot_password') }}
                                                        </a>
                                                </div>
                                            </div>
                                        </div>                                        


                                        <div class="form-group">
                                            <div class="clearfix signin_options">
                                                <a href="javascript: void(0)" v-google-signin-button="clientId" class="sign-in-google">
                                                    <div class="image-block">
                                                        <img src="static/assets/images/Google-512.webp" width="20px" />
                                                    </div>
                                                    <div class="button-font">
                                                        <span>
                                                        Sign in  with Google
                                                        </span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                        <vue-apple-login
                                            mode="center-align"
                                            type="sign in"
                                            color="white"
                                            :border="true"
                                            :radius="20"
                                            width="200"
                                            height="36"
                                            logoSize="large"
                                            :logoPosition="0"
                                            :labelPosition="0"
                                            className="vue-apple-login"
                                            response_mode="web_message"
                                            :onSuccess="onAppleAuthSuccess"
                                            :onFailure="onAppleAuthFail"
                                        ></vue-apple-login>

                                        <div class="o-error-msg" v-if="credential_err.length && credential_err=='Invalid login credentials! please visit the faq at https://cs3.m3/ilc'">
                                            <div class="error-note">
                                                <span>{{ $t('invalid_login_credentials') }}</span>
                                                <span>{{ $t('please_visit_faq') }}</span>
                                                <br />
                                                <a href="https://cs3.me/ilc" class="text-white1" target="_blank"> Faq-Invalid Login Credentials </a>
                                            </div>
                                        </div>
                                        <div class="o-error-msg" v-else-if="credential_err.length">
                                            <div class="error-note">
                                                <span>{{ credential_err }}</span>
                                                <!-- <span>{{ $t('invalid_login_credentials') }}</span>
                                                <span>{{ $t('please_visit_faq') }}</span> -->
                                                <!-- <br /> -->
                                                <!-- <a href="https://cs3.me/ilc" class="text-white1" target="_blank"> Faq-Invalid Login Credentials </a> -->
                                            </div>
                                        </div>
                                    </form>
                                   </div>
                                </transition>
                                <transition name="">
                                    <div v-if="tab == 'forgetScreen'" class="forget-screen">
                                        <form>
                                            <div class="form-group">
                                                <div class="clearfix">
                                                    <div class="form-group-left o-login-field">
                                                        <!-- <label>E-MAIL :</label> -->
                                                        <label>{{ $t('email') }} :</label>
                                                    </div>
                                                    <div class="form-group-right o-login-field">
                                                        <input @keyup="passwordReset" type="email" class="form-control u-transparent" :placeholder="$t('enter_your_email')" v-model="resetemail" id="resetemail" v-validate="{ required: true, email: true }" name="resetemail">
                                                        <span v-show="errors.has('resetemail') && this.validation_err!=0" class="err-msg">{{ errors.first('resetemail') }}</span>
                                                        <div class="text-right ps2">
                                                            <a href="javascript: void(0)" @click="goToLogin()" class="o-forget-password">
                                                                <!-- Log in? -->
                                                                {{ $t('login') }}?
                                                                </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="clearfix">
                                                    <a href="javascript: void(0)" @click="getResetLink()" class="c-solid-btn c-solid-btn--green o-login-btn">
                                                        <!-- Get Reset Link -->
                                                        {{ $t('get_reset_link') }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="o-error-msg">
                                                <span :class="resetInfo_err.length?'error-note':''" v-if="resetInfo_err.length">{{this.resetInfo_err}}</span>
                                            </div>
                                        </form>
                                    </div>
                                </transition>
                                <transition name="">
                                    <div v-if="tab == 'successPassword'" class="successPassword-screen">
                                 
                                        <div class="login-success-note">
                                          <!-- <h1>Thank you</h1>thank_you -->
                                          <!-- <h3>Your reset link has been sent to your registerd email address</h3> -->
                                          <h1>{{ $t('thank_you') }}</h1>
                                          <h3>{{ $t('reset_link_email_message') }}</h3>
                                        </div>
                                        <div class="">
                                            <div class="clearfix">
                                                <div class="text-center ps2">
                                                    <a href="javascript: void(0)" @click="goToLogin()" class="o-forget-password"><i class="fa fa-angle-double-right" aria-hidden="true"></i> 
                                                    <!-- Go To Login -->
                                                    {{ $t('go_to_login') }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                           
                                    </div>
                                </transition>
                            </div>
                        </div>
                    
                        <!-- <p class="ps2 text-center u-margin-20">After logging in for the first time, please change your password, and user name if desired. Verify all personal information, and assign your skills.</p> -->
                        <!-- <a href="javascript: void(0)" class="ps2 text-center display-block">Privacy policy</a> -->
                        <p class="ps2 text-center u-margin-20">{{ $t('login_page_verify_text') }}</p>
                        <a href="javascript: void(0)" class="ps2 text-center display-block">{{ $t('privacy_policy') }}</a>
                    </div>
                    <!-- <div class="col-md-5 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left login-left-spacing">
                                <img v-if="login_image && login_image != '' && login_image != 'NULL'" :src="login_image" width="100"/>
                                <img v-if="!login_image || login_image == '' || login_image == 'NULL'" src="static/assets/images/logo.png" width="100" />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right login-right-spacing">
                                <transition name="">
                                    <div class="login-screen login-right-screen">
                                        <p v-html="login_text"></p>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

      </div>
</template>
<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';
    import GoogleSignInButton from 'vue-google-signin-button-directive'

    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',
                employeeId: 'employeeId',
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getBrowserSettingsLanguage: 'getBrowserSettingsLanguage',
                userLanguage: 'userLanguage'
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                            
                return("desktop" != check ? !0 : !1);

            },
        },
        data() {
            return {
                preferedLanguages: [
                    {
                        label: 'english',
                        value: 'en'
                    },
                    {
                        label: 'spanish',
                        value: 'es'
                    },
                    {
                        label: 'french',
                        value: 'fr'
                    }
                ],
                languageSelected: '',
                loginHide:true,
                email: "",
                password: "",
                validation_err: 0,
                credential_err: "",
                tab: 'loginScreen',
                resetemail: '',
                resetInfo_err: '',
                redirect_link: '',
                domainLogo: '',
                getBaseURL: '',
                getClientBase: '',
                login_image:'',
                login_text:'',
                clientdata:null,
                loading:false,
                clientId: "508718336686-s1b3dg4trrs2fk287qsegbregbthkiuu.apps.googleusercontent.com"
            }
        },
        directives: {
            GoogleSignInButton
        },
        watch: {
            email: function() {
                this.credential_err = "";
            },
            password: function() {
                this.credential_err = "";
            }
        },
        methods: {
            onLanguageSelected() {
                // console.log(this.languageSelected);
                localStorage.setItem("lang", this.languageSelected);
                this.$store.dispatch('saveBrowserSettingsLanguage', this.languageSelected);
                // console.log(localStorage.getItem("lang"));
                // console.log(this.languageSelected);
                location.reload();
            },

            connectWithGoogle() {
                this.$Progress.start();
                service.get('auth/authorizeRequest', { url: window.location.href })
                    .then((res) => {
                        // console.log(res.data.result.dataSet);
                        let path = res.data.result.dataSet;
                        this.$Progress.finish();
                        // console.log(path);
                        window.location.href = path;
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.fail();
                        this.credential_err = this.$t('something_went_wrong');
                    });
            },

            loginWithGoogle(idToken) {
                // console.log(idToken);
                this.$Progress.start();
                // console.log("Google Connection")
                service
                .post('auth/socialLogin', {
                    url: window.location.href,
                    idToken: idToken
                })
                .then(async (res) => {
                    await this.getIntoApp(res);
                })
                .catch((err) => {
                    this.$Progress.fail();
                    this.credential_err = this.$t('something_went_wrong');
                });
            },

            loginWithApple(appleResponse) {
                this.$Progress.start();
                service
                .post('auth/appleLogin', {
                    idToken: appleResponse.authorization.id_token,
                    url: window.location.href
                })
                .then(async (res) => {
                    await this.getIntoApp(res);

                }).catch((err) => {
                    this.$Progress.fail();
                    this.credential_err = this.$t('something_went_wrong');
                });
            },

            passwordReset() {
                this.resetInfo_err = "";
            },

            getResetLink() {
                this.$Progress.start();
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        service.post('auth/forgotPassword', {
                            redirect_link: this.redirect_link,
                            email: this.resetemail,
                        }, {}).then((res) => {
                            if (res.data.result.status == 0) {
                                this.$Progress.fail();
                                this.resetInfo_err = res.data.result.message;
                                //console.log('incorrect');
                            } else {
                                //console.log('correct');
                                this.tab = "successPassword";
                                this.resetInfo_err = "";
                                this.$Progress.finish();
                            }

                        }).catch((err) => {
                            this.$Progress.fail();
                            this.resetInfo_err = this.$t('something_went_wrong');
                        });

                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            goToForget() {
                this.tab = "forgetScreen";
                this.resetemail = "";
            },

            goToLogin() {
                this.tab = "loginScreen";
                this.email = "";
                this.password = "";
            },

            validate: function() {
                this.$Progress.start();
                this.$validator
                .validateAll()
                .then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        this.loading = true;                        
                        service
                        .post('auth/login', {
                            email: this.email,
                            password: this.password,
                            url: window.location.href,
                            language: this.languageSelected
                        })
                        .then(async (res) => {
                            await this.getIntoApp(res);                            
                        })
                        .catch((err) => {
                            this.$Progress.fail();
                            this.loading=false;
                            this.credential_err = this.$t('something_went_wrong');
                        });
                    } else {
                        this.loading = false;
                        this.validation_err = 1;
                    }
                });
            },
            
            domainIdentify() {
                this.loading=true;
                service.get('auth/domain', {
                        'url': document.location.href.split('#')[0] + "#/login",
                    })
                    .then((res) => {
                        // console.log(res);
                        this.domainLogo = (res.data.result)?res.data.result.logo:null;
                        this.clientdata=(res.data.result)?res.data.result:null;
                        this.login_image=this.clientdata.login_image;
                        this.login_text=this.clientdata.login_page_message;
                        //console.log("Domain", this.clientdata);
                        this.loading=false;
                        if(res.data.result==null && document.location.href.split('#')[0] != 'http://localhost:8080/' && document.location.href.split('#')[0] != 'https://labour.' + global[0].CLIENT_BASE) {
                            this.$router.push({
                                path: "/pageNotFound"
                            }); 
                        }

                    }).catch((err) => {
                        this.loading=false;
                        this.$Progress.fail();
                    });
            },

            cleanCookiesData() {                
                // remove chart icon.
                // window.fcWidget.init({
                //     token: "5f5b4092-cff9-4586-9c85-5d4c79365f71",
                //     host: "https://wchat.freshchat.com",
                //     config: {
                //       headerProperty: { 
                //         hideChatButton: true 
                //       } 
                //     }
                // });

                //clear cookies & local data.
                this.$cookies.remove("csLogin", "/mobile");
                this.$cookies.remove("csLogin");
                this.$cookies.remove("date_format");
                this.$cookies.remove("time_format");
                this.$cookies.remove("time_zone");
                localStorage.removeItem('vuex');
                this.$store.dispatch('setTokenExpiry', '');
                localStorage.clear();
            },

            OnGoogleAuthSuccess (idToken) {
                this.loginWithGoogle(idToken); // Receive the idToken and make your magic with the backend
            },

            OnGoogleAuthFail (err) {
                // console.log(err.error);
                this.$notify.error({
                    title: 'Error',
                    message: err.error
                })
            },

            onAppleAuthSuccess(res) {
                // console.log("Success")
                // console.log(res.authorization.id_token);
                // console.log(res);
                this.loginWithApple(res);
            },

            onAppleAuthFail(err) {
                // console.log(err.detail.error);
                this.$notify.error({
                    title: 'Error',
                    message: err.detail.error
                })
            },

            async getIntoApp(res) {
                localStorage.removeItem('vuex');
                if (res.data.status_code == 0) {
                    this.$Progress.fail();
                    this.loading = false;
                    this.credential_err = res.data.status_message;
                    // console.log(this.credential_err);
                } else {
                    let data = res.data.result;
                    // console.log(data.token_expiry);

                    console.log(data.token_expiry);
                    this.$store.dispatch('setTokenExpiry', data.token_expiry);

                    // console.log('correct',  data);
                    this.$store.dispatch('userSession', data);
                    this.$store.dispatch('setLoginSuper', false);
                    // console.log('***************** ');
                    this.$cookies.set("csLogin", data.role.slug, "23h");
                    this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                    this.credential_err = "";
                    this.$Progress.finish();
                    $('.wrapper').css('margin-left', '60px');
                    /* for support chat box.*/
                    let self = this;
                    var a = JSON.parse(localStorage.getItem('vuex'));
                    var userRole = a && a.user && a.user.userData && a.user.userData.role?a.user.userData.role.slug:null;
                    // console.log('correct 1');
                    if(userRole){
                        var tags =['csSupport'];
                        var restoreId =null;
                        var client = null;
                        var phone ='';
                        var user_id ='';
                        var first_name="";
                        var last_name="";
                        var email=""
                        if(a.user.userData.user && a.user.userData.user.freshchat){
                            restoreId = a.user.userData.user.freshchat.restore_id;
                        }
                        if(userRole!='employer-admin' && userRole!='employer' && userRole!='super-admin' && a.user.userData.user && a.user.userData.user.employees && a.user.userData.user.employees.length && a.user.userData.user.employees[0].client_employee && a.user.userData.user.employees[0].client_employee.clients){
                            client = a.user.userData.user.employees[0].client_employee.clients.subdomain;
                        }
                        if(a.user.userData.user){
                            user_id = a.user.userData.user.id;
                            first_name = a.user.userData.user.first_name;
                            last_name = a.user.userData.user.last_name;
                            email = a.user.userData.user.email;
                            if(a.user.userData.user.phones && a.user.userData.user.phones.length){
                                phone = a.user.userData.user.phones[0].phone_number;
                            }
                        }
                        if(userRole=='employee' || userRole=='power-user'){                                            
                            if(a.user.userData.user && a.user.userData.user.employees){
                                for(var key in a.user.userData.user.employees){
                                    if(a.user.userData.user.employees[key].client_employee && a.user.userData.user.employees[key].client_employee.clients && a.user.userData.user.employees[key].client_employee.clients["widget_tags"]){
                                        var temp_tags = JSON.parse(a.user.userData.user.employees[key].client_employee.clients["widget_tags"]);
                                        if(temp_tags && temp_tags.length){
                                            tags=tags.concat(temp_tags)
                                        }
                                    }
                                }
                            }
                        }
                        localStorage.setItem('tags', JSON.stringify(tags));
                        // console.log(window.fcWidget);                        
                        await window.fcWidget.init({
                            token:"5f5b4092-cff9-4586-9c85-5d4c79365f71",
                            host: "https://wchat.freshchat.com",
                            externalId: a.user.userData.user.id,
                            restoreId: restoreId ? restoreId : null,
                            tags: tags,
                            config: {
                                headerProperty: {
                                backgroundImage: 'https://admin.callsteward.com/static/assets/images/login-bg.jpg',
                                //Hide the chat button on load
                                hideChatButton: false,
                                //Set Widget to be left to right.
                                // direction: 'ltr'
                                }
                            }
                        });
                        // console.log("Check 0:")
                        await window.fcWidget.user.get(function(resp) {
                            console.log("Check 1", resp);
                            var status = resp && resp.status,
                            data = resp && resp.data;
                            console.log('Get User Success', resp);
                            if (status !== 200) {
                                console.log('Get User not 200', resp)
                                window.fcWidget.user.setProperties({
                                    firstName: a.user.userData.user.first_name,              // user's first name
                                    lastName: a.user.userData.user.last_name,                // user's last name
                                    email: a.user.userData.user.email,    // user's email address
                                    phone: String(phone),            // phone number without country code
                                    client: String(client),   // user's meta property 3
                                    role: String(userRole),
                                    plan: "Estate",                 // user's meta property 1
                                    status: "Active",               // user's meta property 2
                                    "Restore Id": restoreId?restoreId:null
                                });
                                console.log("FcWidget created Start");
                                window.fcWidget.on('user:created', ((resuser) => {
                                    console.log('on User created', resuser)
                                    var status = resuser && resuser.status,
                                        data = resuser && resuser.data;
                                    if (status == 200 || status == 201) {
                                        if (data.restoreId) {
                                            console.log('on restored id found', resuser)
                                            let formData={
                                                userId: a.user.userData.user.id,
                                                aliasId: data.alias,
                                                restoreId: data.restoreId
                                            }
                                            // console.log('setProperties', formData);
                                            service.post('employee/saveFreshchatId', formData, {
                                                'Authorization': self.userToken,
                                                'cs3-context-role': self.userRole,
                                                'cs3-context-clientId': self.userClientID,
                                            })
                                            .then((res) => {
                                                console.log('updated fresh chat Ids.')
                                            }).catch((err) => {
                                                console.log(err);
                                            })
                                        }
                                    }
                                }));
                            }else {
                                console.log(data);
                            }
                        });
                    }
                    /* END CHAT SUPPORT */
                    if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "auditor") {
                        if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                            // console.log('***************** 1');
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                            this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                            this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                        }
                        // console.log('***************** 2');
                        if (data.role.slug == "client-admin" || data.role.slug == "power-user") {
                            this.$store.dispatch('setLastOpenJob', 0);
                            //for heard refresh.
                            //location.reload(true);
                            if(data.role.slug == "power-user"){
                                this.$router.push({
                                    path: "/switchClient"
                                });
                            }
                            else{
                                this.$router.push({
                                    path: "/jobList"
                                });
                            }
                        } else {
                            if(document.getElementsByTagName('body')[0].clientWidth < 700)
                            {
                                this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                                this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                                this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                                window.location.href = window.location.href.split('#')[0]+"mobile/";
                            } else{
                                //for heard refresh.
                                //location.reload(true);


                                this.$router.push({
                                    path: "/switchClient"
                                });


                                // this.$router.push({
                                //     path: "/schedule/"+btoa(this.employeeId),
                                // });
                            }
                        }

                    } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                        // console.log("Hi I am Employer Admin.");
                        window.location.reload(true);
                        this.$router.push({
                            path: "/employerJobList"
                        });

                    } else if(data.role.slug == "super-admin") {
                        //location.reload(true);
                        this.$router.push({
                            path: "/clientList"
                        });
                    }                                
                }
                this.loading=false;
            }
        },

        mounted() {
            // console.log(this.getBrowserSettingsLanguage);
            if(this.userLanguage && this.userLanguage != '')
                this.languageSelected = this.userLanguage;
            else {
                if(localStorage.getItem("lang") && localStorage.getItem("lang") != '')
                    this.languageSelected = localStorage.getItem("lang");
                else this.languageSelected = 'en'
            }
            localStorage.setItem("lang", this.languageSelected);
            this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));
            //alert('created');
            $('.loginVue').parent('.wrapper').css('margin-left', '0');
            this.cleanCookiesData();

            const isMobile = this.deviceDetector;
            // console.log('deviceDetector',isMobile);
            if(isMobile && (window.location.hostname !='localhost')){
                viewport.setAttribute('content', 'width=1024');
                window.location.href = window.location.href.split('#')[0]+"mobile/";
            }else{
                this.loginHide = true;
                viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no');
            }
            
        },
        beforeMount() {
            // console.log(window.location.hostname);
            this.getBaseURL = global[0].IMAGE_URL;
            this.getClientBase = global[0].CLIENT_BASE;
            console.log("Global Elements: .......", global);
            // let winLocHref = window.location.hostname;
            // let dummy = '.' + this.getClientBase
            // let split1 = document.location.href.split(dummy)[0]
            // let sub_domain = split1.split('//')[1]
            // // let sub_domain = (winLocHref != 'localhost')?this.getClientBase.split('.')[0]:'No Sub-domain';
            // // console.log(sub_domain);
            
            // if((winLocHref != 'localhost')&&(sub_domain != 'labour')&&(sub_domain != 'login')&&(sub_domain != 'admin')) {
            //     // console.log(sub_domain);
            //     window.location.href = 'https://login.'+this.getClientBase+"#/login";
            // }else {
            //     // console.log(sub_domain);
            // }
        },
         // beforeMount() {
            // let lang = localStorage.getItem("lang");
            // if (lang && lang != '') {
            //     localStorage.setItem("lang", lang);
            // } else {
            //     let locLang = (navigator.language || navigator.userLanguage).split('-')[0];
            //     if (locLang && locLang == 'es') {
            //         lang = 'es';
            //     } else if(locLang && locLang == 'fr') {
            //         lang = 'fr';
            //     } else {
            //         lang = 'en';
            //     }
            //     localStorage.setItem("lang", lang);
            // }
            // this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));
        // },
               
        created() {
            // if(document.getElementsByTagName('body')[0].clientWidth < 700 && document.location.href.split('#')[0] !='http://localhost:8080/'){
            //     window.location.href = window.location.href.split('#')[0]+"mobile/";
            // }else{
            //     this.loginHide = true;
            // }

            /* switch view port for mobile/desktop */
            
            this.redirect_link = document.location.href.split('#')[0] + "#/resetPassword";
            //alert('created');
            //$('.loginVue').parent('.wrapper').css('margin-left', '0');
            this.domainIdentify();
        }
    }

</script>
<style scoped>
    .text-white1{
    color: #ffffff;
  }
    .forget-float-right {
        float: right;
        font-weight: 600;
    }

    .font-red {
        color: #fe1f1f;
    }

    .signin_options {        
        /* display: flex;
        flex-direction: column;
        justify-content: center; */
    }

    .login-center {
        left: 60%;
    }

    .signin_options .sign-in-google {
      display: flex;
      flex-direction: row;
      justify-items: center;
      width: 200px;
      height: 36px;
      border-radius: 2px;
      padding: 1px;
      background-color: #4285F4;
  }

  .signin_options .sign-in-google .image-block {
    height: 34px;
    width: 34px;
    background-color: #ffffff;
    text-align: center;
    vertical-align: middle;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 5px;
  }

  .signin_options .sign-in-google .image-block img {
      background-color: #FFFFFF;
      height: 24px;
      width: 24px!important;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
  }

  .signin_options .sign-in-google .button-font{
      margin-top: 8px;
  }

  .signin_options .sign-in-google .button-font span {
    color: #FFFFFF;
    font-size: 16px;
    vertical-align: middle;
    padding: 10px;
    font-weight: 500;
    font-family: 'Roboto', 'Helvetica';
  }

    #page {
        visibility: visible !important;
    }

    .loginVue {
        min-height: 200px;
    }

    .mb-15 {
        margin-bottom: 15px;
    }
    .fade-enter {
        opacity: 0
    }

    .fade-enter-active {
        transition: opacity .40s ease
    }

    .fade-leave {}

    .fade-leave-active {
        transition: opacity .40s ease;
        opacity: 0
    }

    button.login-button {
      background-color: white;
      height: 36px;
      width: 200px;
      border-radius: 5px;
      border: 2px;
      font-size: 12px;
      font-weight: 500;
      margin: 5px;
    }
    button.login-button svg{
      height: 30px;
      margin-top: -3px;
      margin-right: 3px;
    }

    /*.fade-enter-active,
    .fade-leave-active {
        transition-property: opacity;
        transition-duration: .40s;
    }

    .fade-enter-active {
        transition-delay: .40s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }*/

</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue